import { Component, OnInit } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { provideNgxMask } from 'ngx-mask';
import {ConsultingService, LoaderService, ReportService} from "@app/shared";
import {PageHeaderComponent} from "@app/components/page-header/page-header.component";
import {UtilsInjectable} from '@app/shared';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
    selector: 'app-soa-payment',
    templateUrl: './soa-payment.component.html',
    styleUrls: ['./soa-payment.component.scss'],
    animations: [routerTransition()],
    imports: [CommonModule, FormsModule, SelectDropDownModule, PageHeaderComponent],
    providers: [DatePipe, provideNgxMask()],
})
// ...imports same as before

export class SoaPaymentComponent implements OnInit {
    customers: any[] = [];
    invoiceList: any[] = [];
    public vendor_options: any;
    public vendor_data: any;
    totalBalance: number = 0;
    vendor_id: any;
    totalInvoiceAmount: number = 0;
    totalReceiptTotal: number = 0;
    public customer_options: any[] = [];
    public user_rights: any = {};
    public user_data: any = {};
    public institution = JSON.parse(localStorage.getItem('institution') || "{}");
    public logo_path = localStorage.getItem('logo_path') || ''; // ✅ FIXED

    dropdownConfig = {
        displayKey: 'CUSTOMER_NAME',
        search: true,
        placeholder: 'Select Customer',
        height: '200px',
        limitTo: 1000
    };

    constructor(private api: ConsultingService, private toastr: ToastrService,
                private reportService: ReportService,
                private loaderService: LoaderService,
                protected utils: UtilsInjectable,

    ) {}

    ngOnInit(): void {
        this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
        this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
        this.listCustomer();
        this.getDropdowns();
    }

    getDropdowns() {
        const postData = {
            vendor_id: ''
        }
        this.loaderService.display(true);
        this.api.listVendor(postData).subscribe((result: any) => {
        this.loaderService.display(false);
        if (result['status'] == 'Success') {
            this.vendor_options = result['data'];
            for (let index = 0; index < this.vendor_options.length; index++) {
            if (this.vendor_options[index].VENDOR_ID == this.vendor_id) {
                this.vendor_data = this.vendor_options[index];
            }
            }
        }
        });
    }

    listCustomer() {
        this.loaderService.display(true);
        this.reportService.listCustomer().subscribe((res: any) => {
            this.loaderService.display(false);
            if(res.status === 'Success'){
                this.customer_options = res.data;
            }
        });
    }

    fetchSOA() {
        if (!this.vendor_id) {
            this.toastr.error('Please select a supplier!');
            return;
        }

        const postData = {
            vendor_id: this.vendor_id
        };

        this.loaderService.display(true);
        this.api.getSupplierSOA(postData).subscribe({
            next: (res: any) => {
                this.loaderService.display(false);

                if (res.status === 'Success' && res.data.length > 0) {
                    this.invoiceList = res.data;
                    this.totalInvoiceAmount = parseFloat(res.totals.total_invoice || 0);
                    this.totalReceiptTotal = parseFloat(res.totals.total_receipt || 0);
                    this.totalBalance = parseFloat(res.totals.balance || 0);
                } else {
                    this.invoiceList = [];
                    this.totalInvoiceAmount = 0;
                    this.totalReceiptTotal = 0;
                    this.totalBalance = 0;
                    this.toastr.info('No records found for this customer.');
                }
            },
            error: (err) => {
                this.loaderService.display(false);
                console.error('Error fetching SOA:', err);
                this.toastr.error('Failed to fetch SOA data.');
            }
        });
    }
    downloadPDF() {
        if (!this.invoiceList || this.invoiceList.length === 0) {
            this.toastr.info('No data available to export.');
            return;
        }

        const doc = new jsPDF('p', 'mm', 'a4');
        const inst = this.institution;
        const pageWidth = doc.internal.pageSize.getWidth();
        const logoUrl = (inst.INSTITUTION_LOGO ? this.logo_path + inst.INSTITUTION_LOGO : '').replaceAll('"', '');

        // Helper to generate PDF
        const generatePDF = (logoImg: HTMLImageElement | null = null) => {
            // --- HEADER ---
            const marginY = 10;
            const logoX = 14;
            const textX = pageWidth - 14; // Right-aligned institution info

            // --- Add logo (larger but keeps aspect ratio) ---
            if (logoImg) {
                const maxLogoWidth = 40;  // increased from 25 → 40 mm
                const maxLogoHeight = 40; // increased from 25 → 40 mm
                const ratio = Math.min(maxLogoWidth / logoImg.width, maxLogoHeight / logoImg.height);

                const displayWidth = logoImg.width * ratio;
                const displayHeight = logoImg.height * ratio;
                const logoY = marginY;

                doc.addImage(logoImg, 'PNG', logoX, logoY, displayWidth, displayHeight);
            }

            // --- Institution Name ---
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(14);
            doc.text(inst.INSTITUTION_NAME || 'Institution Name', textX, marginY + 6, { align: 'right' });

            // --- Institution Details ---
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            let infoY = marginY + 12;
            if (inst.INSTITUTION_ADDRESS)
                doc.text(inst.INSTITUTION_ADDRESS, textX, infoY, { align: 'right' });
            infoY += 5;
            doc.text(`${inst.INSTITUTION_CITY || ''}, ${inst.INSTITUTION_COUNTRY_NAME || ''}`, textX, infoY, { align: 'right' });
            infoY += 5;
            if (inst.INSTITUTION_PHONE_NO)
                doc.text(`Ph: ${inst.INSTITUTION_PHONE_NO}`, textX, infoY, { align: 'right' });
            infoY += 5;
            if (inst.INSTITUTION_EMAIL)
                doc.text(`Email: ${inst.INSTITUTION_EMAIL}`, textX, infoY, { align: 'right' });
            infoY += 5;
            if (inst.INSTITUTION_VAT_NO)
                doc.text(`VAT IN: ${inst.INSTITUTION_VAT_NO}`, textX, infoY, { align: 'right' });

            // --- TITLE SECTION ---
            const titleY = infoY + 10; // space after header
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(13);
            doc.text('Statement of Account', pageWidth / 2, titleY, { align: 'center' });

            // --- Supplier Section ---
            const supplierY = titleY + 8; // space below title
            doc.setFontSize(11);
            doc.setFont('helvetica', 'normal');
            doc.text(`Supplier: ${this.vendor_data || '-'}`, 14, supplierY);

            // --- TABLE ---
            const tableStartY = supplierY + 8;
            const tableBody = this.invoiceList.map((row: any) => [
                row.invoice_date || '-',
                row.invoice_no || '-',
                this.formatAmount(row.invoice_amt),
                row.receipt_date || '-',
                row.receipt_no || '-',
                this.formatAmount(row.receipt_amt),
            ]);

            autoTable(doc, {
                startY: tableStartY,
                head: [
                    [
                        { content: 'Invoice Date', styles: { halign: 'center' } },
                        { content: 'Invoice No', styles: { halign: 'center' } },
                        { content: 'Invoice Amount', styles: { halign: 'right' } },
                        { content: 'Receipt Date', styles: { halign: 'center' } },
                        { content: 'Receipt No', styles: { halign: 'center' } },
                        { content: 'Receipt Amount', styles: { halign: 'right' } },
                    ],
                ],
                body: tableBody,
                theme: 'grid',
                headStyles: {
                    fillColor: [211, 211, 211],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold'
                },
                bodyStyles: { fontSize: 10 },
                styles: { halign: 'center' },
            });

            // --- TOTALS ---
            const finalY = (doc as any).lastAutoTable.finalY + 10;
            doc.setFontSize(11);
            doc.text(`Total Invoice: ${this.formatAmount(this.totalInvoiceAmount)}`, 14, finalY);
            doc.text(`Total Receipt: ${this.formatAmount(this.totalReceiptTotal)}`, 90, finalY);
            doc.text(`Balance: ${this.formatAmount(this.totalBalance)}`, 160, finalY);

            // --- FOOTER ---
            const footerY = doc.internal.pageSize.getHeight() - 10;
            doc.setFontSize(9);
            doc.text(
                `${inst.INSTITUTION_NAME || ''} | ${inst.INSTITUTION_EMAIL || ''}`,
                pageWidth / 2,
                footerY,
                { align: 'center' }
            );

            // --- SAVE FILE ---
            doc.save(`SOA_${this.vendor_data || 'Supplier'}.pdf`);
        };

        // --- Load logo image (optional) ---
        if (logoUrl) {
            const logoImg = new Image();
            logoImg.crossOrigin = 'anonymous';
            logoImg.src = logoUrl;

            logoImg.onload = () => generatePDF(logoImg);
            logoImg.onerror = (err) => {
                console.error('Logo failed to load:', logoUrl, err);
                this.toastr.warning('Logo not found. Generating PDF without logo.');
                generatePDF(null);
            };
        } else {
            generatePDF(null);
        }
    }





// Helper to ensure number formatting is safe
    private formatAmount(value: any): string {
        const num = parseFloat(value);
        return isNaN(num) ? '0.00' : num.toFixed(2);
    }



    getVendor(data: any) {
        if (data['value']) {
            this.vendor_id = data['value'].VENDOR_ID;
            this.vendor_data = data['value'].VENDOR_NAME;
        }
    }


}
